import { UserCredentialsStatus } from '@ply-io/ply-front-shared-utilities';
import {
	PER_USER_CONNECTION_ID,
	PER_ACCOUNT_CONNECTION_ID,
	PROFILE_FROM_CONFIGURATION_CREDENTIALS_TYPES,
} from './credentials-service.const';
import { PROJECTS_ENTITY, PROJECTS_SENSITIVE_TYPE } from './projects.const';
// Private
const getProfileItem = (id, connectionName, status) => ({ id, connection_name: connectionName, status });

// Public
const getPerUserProfileItem = () => getProfileItem(PER_USER_CONNECTION_ID, 'Per user connection', UserCredentialsStatus.Success);
const getPerAccountProfileItem = () => getProfileItem(PER_ACCOUNT_CONNECTION_ID, 'Per account connection', UserCredentialsStatus.Success);

const isConnectionFromConfiguration = (credentialsType) => PROFILE_FROM_CONFIGURATION_CREDENTIALS_TYPES.includes(credentialsType);

const isConnectionPersonal = (credentials) => !credentials?.access?.is_related;
const isConnectionRelatedToProject = (credentials, projectId) =>
	credentials?.access?.is_related &&
	credentials?.access?.related_entity_id == projectId && // == on purpose sometimes the project is string and sometimes number
	credentials?.access?.related_entity_type === PROJECTS_ENTITY;
const isConnectionRelatedToProjectAndSensitive = (credentials, projectId) =>
	isConnectionRelatedToProject(credentials, projectId) && credentials?.access?.type === PROJECTS_SENSITIVE_TYPE;
const isConnectionRelatedToProjectAndNotSensitive = (credentials, projectId) =>
	isConnectionRelatedToProject(credentials, projectId) && credentials?.access?.type !== PROJECTS_SENSITIVE_TYPE;

const isConnectionStatusSuccessful = (credentials) => credentials?.status === UserCredentialsStatus.Success;

const CredentialsService = {
	getPerUserProfileItem,
	getPerAccountProfileItem,
	isConnectionFromConfiguration,
	isConnectionStatusSuccessful,
	isConnectionPersonal,
	isConnectionRelatedToProject,
	isConnectionRelatedToProjectAndSensitive,
	isConnectionRelatedToProjectAndNotSensitive,
};

export default CredentialsService;
